'use client'
import {Button, EnquireForm} from '@local/ui/components'
import React, {useState} from 'react'
import {useTranslate} from '@local/hooks'

interface EnquireSlideoutProps {
	className?: string
}

const EnquireSlideout: React.FC<EnquireSlideoutProps> = ({className}) => {
	const [isOpen, setIsOpen] = useState(false)
	const locale = useTranslate()

	return (
		<div className={className}>
			<Button
				onClick={() => setIsOpen(true)}
				label={locale('An Enquiry')}
				className='fixed z-[50] top-16 lg:right-20 right-10 px-10 text-12 font-medium hover:opacity-90 transition-opacity duration-200'
				variant='primary'
				small
				aria-label={locale('Open enquiry form')} />
			<EnquireForm
				isOpen={isOpen}
				onClickClose={() => setIsOpen(false)}
				title={locale('Enquire')}
				description={locale('Enquire about our services')}
				successText={locale('Thank you for your enquiry')}
				successTitle={locale('Thank you for your enquiry')}
				listID='enquire'
				retreatList={[]} />
		</div>
	)
}

export default EnquireSlideout
